import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ConnectivityInterceptor } from 'src/service/connectivity.interceptor';
import { TrimInterceptor } from 'src/service/trim.interceptor';
import { LoginComponent } from './login/login.component';
import { ExportMaterialModule } from './material-module';
import { SignupComponent } from './signup/signup.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// import { AllworkspaceComponent } from './allworkspace/allworkspace.component';
import { IconsModule } from './icons/icons.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { WorkspaceComponent } from './workspace/workspace.component';
// import { NewinvoiceComponent } from './newinvoice/newinvoice.component';
import { ReviewinvoiceComponent } from './reviewinvoice/reviewinvoice.component';
import { KeyValuePipe } from './filters/keyvalue.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuardService} from 'src/service/auth-guard.service';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { SettingsComponent } from './settings/settings.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { SignOnComponent } from './sign-on/sign-on.component';
import { DocumentmappingComponent } from './documentmapping/documentmapping.component';
import { DocumentViewerComponent } from './documentmapping/document-viewer/document-viewer.component';
import { MasterCatalogComponent } from './master-catalog/master-catalog.component';


import { SharedModule } from './shared/shared.module';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    // AllworkspaceComponent,
    // WorkspaceComponent,
    // NewinvoiceComponent,
    ReviewinvoiceComponent,
    KeyValuePipe,
    SetpasswordComponent,
    ForgotpasswordComponent,
    SettingsComponent,
    SignOnComponent,
    DocumentmappingComponent,
    DocumentViewerComponent,
    MasterCatalogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ExportMaterialModule,
    MatRadioModule,
    MatCheckboxModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatSlideToggleModule,
    IconsModule,
    NgbModule,
    ClipboardModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: TrimInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ConnectivityInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
